/**
 * Guided tour for the RFIs list view (``RfisPage``).
 *
 * Runs only for users with no RFIs yet — introduces the page so they
 * know how to log one. Users with RFIs see the
 * {@link combined.ts | combined tour} instead.
 */
import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import {
  filtersStep,
  listTableStep,
  newRfiStep,
  widgetsStep,
} from './steps';

export const RFIS_LIST_TOUR_ID = 'rfis.list';

registerTour({
  id: RFIS_LIST_TOUR_ID,
  name: 'RFIs',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.RFIS.id,
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to RFIs',
      body:
        'Track Requests For Information across your project — questions ' +
        'to designers, clarifications, and the answers that come back.',
    },
    newRfiStep,
    widgetsStep,
    filtersStep,
    listTableStep,
  ],
});
